<template>
  <div class="dict">
    <div class="tableStyle">
      <!--新增/删除按钮-->
      <vxe-toolbar size="mini" v-if="!isEdit">
        <template v-slot:buttons>
          <vxe-button
            type="primary"
            icon="el-icon-plus"
            class="vxe-btn-primary"
            @click="insertEvent()"
            >{{ $t('xTable.insert') }}</vxe-button
          >
          <vxe-button
            type="primary"
            icon="el-icon-delete"
            class="vxe-btn-delete"
            @click="deleteEvent()"
            >{{ $t('xTable.delete') }}</vxe-button
          >
        </template>
      </vxe-toolbar>
      <vxe-grid
        border
        show-overflow
        resizable
        ref="xTable"
        class="vxe-table-element"
        size="mini"
        align="center"
        :auto-resize="true"
        :data="tableData"
        :edit-rules="goodRules"
        :edit-config="editConfig"
      >
        <vxe-table-column type="checkbox" width="50" fixed="left"></vxe-table-column>
        <vxe-table-column type="index" width="60" :title="$t('table.index')"></vxe-table-column>
        <vxe-table-column field="batchNo" width="200" :title="$t('logisticsLOR.goodList.batchNo')">
        </vxe-table-column>
        <!-- =========================================== -->
        <vxe-table-column
          field="productNo"
          width="160"
          :title="$t('lossOverflowReport.goodList.productNo')"
          :edit-render="{ name: 'input' }"
        >
          <template v-slot:edit="{ row }">
            <SearchModal
              width="800"
              ref="searchModal"
              className="customer-search"
              :model="row.productNo"
              :placeholder="$t('lossOverflowReport.goodList.productNoPlaceholder')"
              :API="inboundList.API"
              :query="inboundList.query"
              :searchColumns="inboundList.searchColumns"
              :page="true"
              :isMultiple="true"
              :currentValue="row.productNo"
              :checkRowKeys="[row.productNo]"
              :columnList="inboundList.columnList"
              @setSearchModal="(val, select) => setInboundNo(val, select, row)"
            ></SearchModal>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="productName"
          width="160"
          :title="$t('lossOverflowReport.goodList.productName')"
        />
        <vxe-table-column
          field="partnerName"
          width="160"
          :title="$t('lossOverflowReport.goodList.partner')"
        />
        <vxe-table-column
          field="decreaseOverflowQuantity"
          width="160"
          :title="$t('lossOverflowReport.goodList.decreaseOverflowQuantity')"
          :edit-render="{ name: 'input' }"
        >
          <template v-slot:edit="{ row }">
            <input-number-ad
              v-model="row.decreaseOverflowQuantity"
              max="9999999999999"
              :precision="$globalVar.qPoint"
              @input="(val) => changeAmount(val, row)"
            ></input-number-ad>
          </template>
          <template v-slot="{ row }">{{
            (decreaseOverflowType ? (decreaseOverflowType == '0' ? '- ' : '+') : '') +
            row.decreaseOverflowQuantity
          }}</template>
        </vxe-table-column>
        <vxe-table-column
          field="decreaseOverflowPackage"
          width="160"
          :title="$t('lossOverflowReport.goodList.decreaseOverflowPackage')"
          :edit-render="{ name: 'input' }"
        >
          <template v-slot:edit="{ row }">
            <input-number-ad
              v-model="row.decreaseOverflowPackage"
              :max="999999999.999999"
              :precision="$globalVar.qPoint"
              @input="(val) => changePackage(val, row)"
            ></input-number-ad>
          </template>
          <template v-slot="{ row }">
            <div v-if="row.decreaseOverflowPackage == '' || row.decreaseOverflowPackage == 0">
              {{
                (decreaseOverflowType ? (decreaseOverflowType == '0' ? '' : '') : '') +
                $baseRequest.formatTableColumn(row.decreaseOverflowPackage, $globalVar.qPoint)
              }}
            </div>
            <div v-else>
              {{
                (decreaseOverflowType ? (decreaseOverflowType == '0' ? '- ' : '+') : '') +
                $baseRequest.formatTableColumn(row.decreaseOverflowPackage, $globalVar.qPoint)
              }}
            </div>
          </template>
        </vxe-table-column>
        <!-- <vxe-table-column field="decreaseOverflowUnitName"  width="160" :title='$t("lossOverflowReport.goodList.decreaseOverflowUnit")'/> -->
        <vxe-table-column
          field="newDecreaseOverflowPercent"
          width="160"
          :title="$t('lossOverflowReport.goodList.decreaseOverflowPercent')"
        >
          <template v-slot="scope">
            {{
              $baseRequest.formatTableColumn(
                scope.row.decreaseOverflowPercent,
                $globalVar.iPoint
              ) || 0
            }}%
          </template>
        </vxe-table-column>
      </vxe-grid>
    </div>
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  import rules from '../rules/rules';
  import API from '@/api/wareHouse/logisticsLossOverflowReport.js';
  import inputNumberAd from '@/components/form-item/input-number-advance';
  // import searchTable from '@/components/form-item/search-table';
  import SearchModal from '@/components/SearchModal';
  import XEUtils from 'xe-utils';
  export default {
    name: 'reportProduct',
    components: {
      inputNumberAd,
      // searchTable,
      SearchModal,
    },
    data() {
      return {
        goodRules: rules.productRules,
        editConfig: {},
        tableData: this.defaultData,
        storage: this.storageNo,
      };
    },
    props: {
      //初始化数据
      defaultData: {
        type: Array,
        default: () => [],
      },
      //仓库编码
      storageNo: {
        type: String,
        default: '',
      },
      //部门
      departmentCode: {
        type: String,
        default: '',
      },
      //单据类型
      decreaseOverflowType: {
        type: String,
        default: '',
      },
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo,
      }),
      isEdit() {
        return this.$route.query.isEdit == 'Y';
      },
      //物流库存批次
      inboundList() {
        return {
          width: '800',
          query: {
            storageNo: this.storage,
            tenantCode: this.userInfo.userInfo.tenantCode,
            storageCompanyCode: this.userInfo.userInfo.companyCode,
            storageDepartmentCode: this.departmentCode,
            storageStatus: '0',
            productName: null,
            batchNo: null,
            storageName: null,
            partnerName: null,
          },
          API: API.GET_DISTRIBUTION,
          searchColumns: [
            {
              prop: 'productName',
              name: this.$t('businessReceiptList.search.productName'),
              type: 'input',
            },
            {
              prop: 'batchNo',
              name: this.$t('logisticsLOR.goodList.batchNo'),
              type: 'input',
            },
          ],
          columnList: [
            {
              prop: 'batchNo',
              label: this.$t('logisticsLOR.goodList.batchNo'),
              fixed: 'left',
              width: 140,
            },
            {
              prop: 'storageQuantity',
              label: this.$t('businessReceiptList.table.storageQuantity'),
              fixed: 'left',
              width: 100,
            },
            // { prop: "storageName", label: this.$t("businessReceiptList.search.storageName"),  },
            {
              prop: 'productNo',
              label: this.$t('businessReceiptList.search.productNo'),
              width: 120,
            },
            {
              prop: 'productName',
              label: this.$t('businessReceiptList.search.productName'),
              width: 120,
            },
            { prop: 'gmtCreate', label: this.$t('businessReceiptList.table.gmtCreate') },
          ],
        };
      },
    },
    mounted() {
      this.editConfig = this.isEdit ? {} : { trigger: 'click', mode: 'row' };
    },
    watch: {
      isEdit(newValue) {
        this.editConfig = newValue ? {} : { trigger: 'click', mode: 'row' };
      },
      defaultData(newValue) {
        this.tableData = newValue;
      },
      storageNo(newVlaue) {
        this.storage = newVlaue;
      },
    },
    methods: {
      //新增一行
      insertEvent() {
        if (!this.storage) {
          this.$message({
            showClose: true,
            message: this.$t('lossOverflowReport.msg.selectWarehouse'),
            type: 'error',
          });
          return;
        }
        let record = {
          batchNo: null,
          settleBatchNo: null,
          productNo: null,
          productName: null,
          partnerName: null,
          decreaseOverflowQuantity: 0,
          decreaseOverflowPackage: '',
          decreaseOverflowUnit: null,
          decreaseOverflowUnitPrice: null,
          businessDecreaseOverflowAmount: null,
          decreaseOverflowPercent: 0,
          purchaseNo: null,
          puchaseDetailNo: null,
          puchaseDetailQuantity: null,
          newDecreaseOverflowPercent: 0,
        };
        record = this.$baseRequest.assignObj(record);
        this.$refs.xTable.insert(record).then(({ row }) => this.$refs.xTable.setActiveRow(row));
      },
      //删除行
      deleteEvent() {
        let selectRecords = this.$refs.xTable.getCheckboxRecords();
        if (selectRecords.length) {
          //删除时记录删除明细id
          // selectRecords.map(item => {
          //   if (item.id) {
          //     this.orderDetailDelIds.push(item.id);
          //   }
          // });
          this.$refs.xTable.removeSelecteds();
        } else {
          this.$message({
            showClose: true,
            message: this.$t('xTable.noSelectData'),
            type: 'error',
          });
        }
      },
      //选择库存批次
      setInboundNo(model, value, row) {
        row.batchNo = value ? value[0].batchNo : null;
        row.productNo = value ? value[0].productNo : null;
        row.productName = value ? value[0].productName : null;
        row.decreaseOverflowUnit = value ? value[0].productUnit : null;
        // row.decreaseOverflowUnitName =value? value[0].productUnitName:null;
        row.inboundQuantity = value ? value[0].inboundQuantity : null; //入库数量
        row.decreaseOverflowQuantity = value ? value[0].storageQuantity : 0; //损溢数量
        row.decreaseOverflowPercent = 100;
        this.$refs.xTable.updateData();
      },
      //修改数量
      changeAmount: XEUtils.debounce(function (val, row) {
        let params = {
          decreaseOverflowQuantity: val,
          decreaseOverflowDepartmentNo: this.userInfo.userInfo.departmentCode,
          decreaseOverflowCompanyNo: this.userInfo.userInfo.companyCode,
          productNo: row.productNo,
          storageNo: this.storageNo,
          batchNo: row.batchNo,
        };
        if (val) {
          //计算损溢比例
          this.$axios.post(API.GET_SCALE, params).then((res) => {
            if (res.data.code === 0) {
              row.decreaseOverflowPercent = Number(res.data.data).toFixed(8);
              row.newDecreaseOverflowPercent =
                Number(row.decreaseOverflowPercent, 100).toFixed(6) + '%';
              this.$refs.xTable.updateStatus(row);
            } else {
              row.decreaseOverflowQuantity = 0;
              row.decreaseOverflowPercent = 0;
              row.newDecreaseOverflowPercent = 0;
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'error',
              });
            }
          });
        } else {
          row.decreaseOverflowPercent = 0;
          row.newDecreaseOverflowPercent =
            Number(row.decreaseOverflowPercent, 100).toFixed(6) + '%';
        }
      }, 500),
      //修改件数
      changePackage(val, row) {
        row.allotOutPackage = val;
      },
      //提交/保存
      submit(type) {
        return new Promise((resolve) => {
          if (type == '0') {
            resolve();
          } else {
            this.$refs['xTable'].validate((valid, object) => {
              if (valid) {
                resolve();
              } else {
                this.$refs.xTable.scrollToColumn(object);
                const getTableData = this.$refs.xTable.getTableData().fullData;
                if (getTableData.length == 1) {
                  setTimeout(() => {
                    this.$refs.xTable.scrollTo(null, 50);
                  }, 500);
                }
              }
            });
          }
        });
      },
      //获取表格所有数据
      getValues() {
        const getTableData = this.$refs.xTable.getTableData().fullData;
        let list = [];
        getTableData.forEach((item, index) => {
          const result = Object.assign({}, item, {
            //项目行序号
            decreaseOverflowDetailNo: index + 1,
          });
          list.push(result);
        });
        return list;
      },
    },
  };
</script>
